import React from "react";
import { NavLink } from "react-router-dom";
import "../../style";
// import { ProfileIcon } from '../component/ProfileIcon'
// import { SeacrhInput } from '../component/SeacrhInput'
// import { Button } from '../FormElement/Button'
import Logo from "../Logo";

export default class Navbar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDesktop: false,
      showTooltip: false,
    };

    this.tooltipRef = React.createRef();
  }
  componentDidMount = () => {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    document.addEventListener("click", this.handleDocumentClick);
  };
  componentWillUnmount() {
    document.removeEventListener("click", this.handleDocumentClick);
  }
  updateWindowDimensions = () => {
    this.setState({ isDesktop: window.innerWidth > 800 });
  };
  handleButtonClick = () => {
    this.setState((prevState) => ({
      showTooltip: !prevState.showTooltip,
    }));
  };

  handleOptionClick = () => {
    this.setState({
      showTooltip: false,
    });
  };

  handleDocumentClick = (event) => {
    if (
      this.tooltipRef.current &&
      !this.tooltipRef.current.contains(event.target)
    ) {
      this.setState({
        showTooltip: false,
      });
    }
  };
  render() {
    const { isDesktop } = this.state;
    return (
      <div className="navbar">
        <div className="initial">
          <a href="https://novustrac.com">
            {" "}
            <Logo isShowLabel={true} />
          </a>
        </div>

        {isDesktop ? (
          <div className="logoutSection">
            <NavLink to="/login" role="button" className="element_button login">
              Log in
            </NavLink>

            <div className="tooltip-container" ref={this.tooltipRef}>
            <div
              onClick={this.handleButtonClick}
              className="element_button signup"
            >
              Sign Up ⬇
            </div>

            {this.state.showTooltip && (
              <div className="tooltip" onClick={this.handleOptionClick}>
                <NavLink to="/signup" role="button" className="tooltip-option">
                Farmer Signup
                </NavLink>
                <NavLink
                  to="/CounterPartySignUp"
                  role="button"
                  className="tooltip-option"
                >
                  Counterparty Signup
                </NavLink>
                <NavLink
                  to="/TrucklineSignup"
                  role="button"
                  className="tooltip-option"
                >
                  Truckline Signup
                </NavLink>
              </div>
            )}
          </div>

            {window.location.pathname === "/" && (
              <div class="contactUs">
                <a href="#ConnectSection">CONTACT US</a>
              </div>
            )}
          </div>
        ) : (
          <div className="logoutSection">
            {window.location.pathname !== "/login" && 
            window.location.pathname !== "/forgot-password" && (
              <NavLink
                to="/login"
                role="button"
                className="element_button login"
              >
                Log in
              </NavLink>
            )}
            {window.location.pathname !== "/signup" &&
            window.location.pathname !== "/CounterPartySignUp" &&
            window.location.pathname !== "/TrucklineSignup" &&
              window.location.pathname !== "/" &&
              window.location.pathname !== "/terms-and-conditions" &&
              window.location.pathname !== "/subscription" &&
              window.location.pathname !== "/privacy" && (
                <div className="tooltip-container" ref={this.tooltipRef}>
            <div
              onClick={this.handleButtonClick}
              className="element_button signup"
            >
              Sign Up ⬇
            </div>

            {this.state.showTooltip && (
              <div className="tooltip" onClick={this.handleOptionClick}>
                <NavLink to="/signup" role="button" className="tooltip-option">
                Farmer Signup
                </NavLink>
                <NavLink
                  to="/CounterPartySignUp"
                  role="button"
                  className="tooltip-option"
                >
                  Counterparty Signup
                </NavLink>
                <NavLink
                  to="/TrucklineSignup"
                  role="button"
                  className="tooltip-option"
                >
                  Truckline Signup
                </NavLink>
              </div>
            )}
          </div>
                
              )}
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/public/Navbar.js